import React from 'react';
import { Button } from '@/Components/ui/button';
import { Heading, Text } from '@/Components/ui/typography';
import { Avatar, AvatarFallback } from '@/Components/ui/avatar';
import { Inline } from '@/Components/ui/layout';
import { Heart, Mail, MessageCircle } from 'lucide-react';

function TopDiv({profileData}) {
  // Debug log removed — was leaking employer profile data to console.
  return (
    <div className="flex w-full items-center gap-10 justify-between flex-wrap">
      <div className="flex min-w-[240px] items-center gap-6">
        <Avatar className="w-20 h-20 rounded-full bg-slate-500">
          <AvatarFallback className="bg-slate-500 text-white text-lg">
            {profileData.data.firstName?.[0]}{profileData.data.lastName?.[0]}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col">
          <Heading level="h1" size="2xl" className="font-medium text-slate-900 m-0">
            {profileData.data.firstName} {profileData.data.lastName}
          </Heading>
          <Text size="base" className="text-slate-500 text-base font-normal mt-2 mb-0">
            {profileData.data.title}
          </Text>
        </div>
      </div>
      <div className="flex min-w-[240px] items-start gap-3 flex-wrap">
        <Button variant="ghost" size="icon" className="w-12 h-12 rounded-md bg-blue-50" aria-label="Favorite">
          <Heart className="w-6 h-6" />
        </Button>
        <Button variant="outline" className="flex items-center gap-3 rounded border-2 border-blue-600 text-blue-600 bg-transparent px-6 py-3 font-semibold text-base capitalize">
          <Mail className="w-6 h-6" />
          <span>Send Mail</span>
        </Button>
        <Button variant="outline" className="flex items-center gap-3 rounded border-2 border-blue-600 text-blue-600 bg-transparent px-6 py-3 font-semibold text-base capitalize">
          <MessageCircle className="w-6 h-6" />
          <span>Start Chat</span>
        </Button>
        <Button variant="outline" className="rounded border-2 border-blue-600 text-blue-600 bg-transparent px-6 py-3 font-semibold text-base capitalize">
          View Result
        </Button>
      </div>
    </div>
  );
}

export default TopDiv;